import { 
	GET_DRAWING_OFFICE_WORK_PACKAGE_STATUSES, 
	GET_DRAWING_OFFICE_WORK_PACKAGE_STATUS,
	CREATE_DRAWING_OFFICE_WORK_PACKAGE_STATUS,
	UPDATE_DRAWING_OFFICE_WORK_PACKAGE_STATUS,
	DESTROY_DRAWING_OFFICE_WORK_PACKAGE_STATUS,
} from "./actions"

export function DrawingOfficeWorkPackageStatusesReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_DRAWING_OFFICE_WORK_PACKAGE_STATUSES}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_DRAWING_OFFICE_WORK_PACKAGE_STATUS}_FULFILLED`:
		case `${CREATE_DRAWING_OFFICE_WORK_PACKAGE_STATUS}_FULFILLED`:
		case `${UPDATE_DRAWING_OFFICE_WORK_PACKAGE_STATUS}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_DRAWING_OFFICE_WORK_PACKAGE_STATUS}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { DrawingOfficeWorkPackageStatusesReducer } from "modules/drawing_office/work_package_statuses/reducer"

// drawing_office_work_package_statuses:DrawingOfficeWorkPackageStatusesReducer,
